// Store
import store from '@/store'

async function tokenGuard(to, from, next) {
  const token = to.query.token || localStorage.getItem('TMS_SURVEY_TOKEN')
  localStorage.removeItem('TMS_SURVEY_TOKEN')

  if (token) {
    try {
      await store.dispatch('survey/load', token)
      await store.dispatch('survey/init', token)
      if (store.getters['survey/isSubmitted']) next({ name: 'error-survey-already-submitted' })
      else if (store.getters['survey/isExpired']) next({ name: 'error-survey-expired' })
      else {
        localStorage.setItem('TMS_SURVEY_TOKEN', token)
        next()
      }
    } catch {
      next({ name: 'error-link-not-valid' })
    }
  } else {
    next('/pagina-non-trovata')
  }
}

// Routes
const routes = [
  {
    path: '/compila-questionario',
    name: 'survey-welcome',
    beforeEnter: tokenGuard,
    components: {
      default: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/SurveyWelcome.vue'),
      appBar: () => import(/* webpackChunkName: "group-user-survey" */ '@/components/layout/TheDefaultAppBar.vue'),
    },
  },
  {
    path: '/questionario',
    name: 'survey-user',
    beforeEnter: tokenGuard,
    components: {
      default: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/Survey.vue'),
      appBar: () => import(/* webpackChunkName: "group-user-survey" */ '@/components/layout/TheDefaultAppBar.vue'),
    },
  },
  {
    path: 'anteprima-documento',
    name: 'survey-document-preview',
    beforeEnter: tokenGuard,
    components: {
      default: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/AdminSurveyDocument.vue'),
      appBar: () => import(/* webpackChunkName: "group-user-survey" */ '@/components/layout/TheDefaultAppBar.vue'),
    },
  },

  // {
  //   path: '/questionario',
  //   components: {
  //     default: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/SurveyLayout.vue'),
  //     appBar: () => import(/* webpackChunkName: "group-user-survey" */ '@/components/layout/TheDefaultAppBar.vue'),
  //   },
  //   props: true,
  //   beforeEnter: tokenGuard,
  //   children: [
  //     {
  //       path: '',
  //       name: 'survey-home',
  //       component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/SurveyHome.vue'),
  //     },
  //     {
  //       path: 'frontpage',
  //       name: 'survey-detail',
  //       component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/SurveyFrontpage.vue'),
  //     },
  //     {
  //       path: 'viaggi',
  //       name: 'survey-journeys',
  //       component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/SurveyJourneys.vue'),
  //     },
  //     {
  //       path: 'anteprima-documento',
  //       name: 'survey-document-preview',
  //       component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/AdminSurveyDocument.vue'),
  //     },
  //   ],
  // },
  {
    path: '/questionario-inoltrato',
    name: 'survey-completed',
    component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/SurveyCompleted.vue'),
  },
  {
    path: '/questionario-completato',
    name: 'error-survey-already-submitted',
    component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/errors/SurveyAlreadySubmitted.vue'),
  },
  {
    path: '/link-non-valido',
    name: 'error-link-not-valid',
    component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/errors/LinkNotValid.vue'),
  },
  {
    path: '/questionario-scaduto',
    name: 'error-survey-expired',
    component: () => import(/* webpackChunkName: "group-user-survey" */ '@/views/errors/SurveyExpired.vue'),
  },
]

export default routes
